export function dataFiltered() {
  return (dispatch, getState) => {
    const state = getState()
    dispatch({type: "DATA_FILTERED", filteredData: state.DataApp.get('filteredData'), filteredLocations: state.DataApp.get('filteredLocations') })
  }
}


// WEBPACK FOOTER //
// ./src/actions/data.js